import React from "react";
import Card from "components/card";
import Button from "components/button";
import { Popover } from "antd";
import { USABLE_ICONS } from "variables/constants";

const AwardCard = ({
  title = "",
  date = "",
  icon = "",
  category = "",
}) => {
  const IconComponent =
    icon && USABLE_ICONS[icon] ? USABLE_ICONS[icon] : null;

  return (
    <Card className="flex flex-col gap-6 rounded-2xl border-2 border-purple-200 dark:border-purple-700 bg-gradient-to-br from-purple-50 to-white dark:from-purple-900 dark:to-white/5">
      <div className="p-6">
        <div className="flex flex-col items-center text-center nomination">
          <Popover
            content={title}
            trigger="hover"
            placement="top"
            overlayClassName="reward-popover"
          >
            <div
              className={`icon-style ${category.toLowerCase()} w-10 h-10 !rounded-full shadow-lg border-2 border-white flex items-center justify-center cursor-pointer hover:scale-110 transition-transform`}
            >
              {IconComponent &&
                React.createElement(IconComponent, {
                  className: "w-5 h-5 text-white"
                })}
            </div>
          </Popover>

          <h4 className="font-semibold mt-4 title-text">{title || "-"}</h4>
          <p className="text-sm mt-1 muted-text">{date || "-"}</p>

          <Button
            type="button"
            className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all border bg-white hover:bg-slate-100 shrink-0 h-8 rounded-lg gap-1.5 px-3 w-full mt-4 dark:bg-white/20 dark:text-white"
          >
            Share Achievement
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default AwardCard;